import { render, staticRenderFns } from "./TabView.vue?vue&type=template&id=66b99e3e&scoped=true&"
import script from "./TabView.vue?vue&type=script&lang=js&"
export * from "./TabView.vue?vue&type=script&lang=js&"
import style0 from "./TabView.vue?vue&type=style&index=0&id=66b99e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../steam-app-cms-prod/steam-app-cms/sources/client/fastboot-cms-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b99e3e",
  null
  
)

export default component.exports